<template>
  <div class="contact_form">
    <form
      autocomplete="off"
      @submit="validateForm"
      action="https://docs.google.com/forms/u/1/d/e/1FAIpQLSeudVI9Q_MqDqm6dm1W7vkKHCL2BNOWFO_ejnFCoOayQd9m1A/formResponse?embedded=true"
      method="POST"
    >
      <Textfield
        v-bind="{
                callback:(val)=>{callbackFormField(val,'name')},
                label:'Name',
                type:'text',
                inputValue:formPayload.name.value,
                errorMsg:formPayload.name.error,
                id:'name',
                name:'entry.1902652876',
                required:true,
                }"
      />
      <Textfield
        v-bind="{
                callback:(val)=>{callbackFormField(val,'email')},
                label:'E-mail address',
                type:'text',
                inputValue:formPayload.email.value,
                errorMsg:formPayload.email.error,
                id:'email',
                name:'entry.1612974425',
                required:true
                }"
      />
      <Textfield
        v-bind="{
                callback:(val)=>{callbackFormField(val,'mobile')},
                label:'Mobile number',
                type:'text',
                inputValue:formPayload.mobile.value,
                errorMsg:formPayload.mobile.error,
                id:'mobile',
                name:'entry.348021927',
                required:true
                }"
      />
      <Textfield
        v-bind="{
                callback:(val)=>{callbackFormField(val,'message')},
                label:'What’s your project about?',
                type:'text',
                inputValue:formPayload.message.value,
                errorMsg:formPayload.message.error,
                id:'message',
                name:'entry.1181796856',
                required:false
                }"
      />
      <input type="submit" value="Get in touch" class="button big-btn" />
      <!-- <button ></button> -->
    </form>
  </div>
</template>

<script>
import { Textfield } from "@/Form";
import { regEx } from "@/utils";
import isEmpty from "lodash/isEmpty";
export default {
  name: "contactform",
  props: {
    title: String
  },
  components: { Textfield },
  data() {
    return {
      isValidForm: false,
      formPayload: {
        name: { value: "", error: "" },
        email: { value: "", error: "" },
        mobile: { value: "", error: "" },
        message: { value: "", error: "" }
      }
    };
  },
  computed: {
    text: () => {}
  },
  methods: {
    callbackFormField(value, key) {
      let { formPayload } = this;
      this.formPayload = {
        ...formPayload,
        [key]: { ...formPayload[key], value }
      };
    },
    validateForm(e) {
      let { formPayload } = this;
      const name = formPayload.name.value;
      const email = formPayload.email.value;
      const mobile = formPayload.mobile.value;
// validation message
      let nameErrorMsg,
        emailErrorMsg,
        mobileErrorMsg = "";

      if (isEmpty(name)) {
        nameErrorMsg = "Please enter your name.";
      } else if (!regEx("name").test(name)) {
        nameErrorMsg = "Please enter correct name.";
      } else {
        nameErrorMsg = "";
      }
      if (isEmpty(email)) {
        emailErrorMsg = "Please enter your email.";
      } else if (!regEx("email").test(email)) {
        emailErrorMsg = "Please enter valid email.";
      } else {
        emailErrorMsg = "";
      }
      if (isEmpty(mobile)) {
        mobileErrorMsg = "Please enter your phone number.";
      } else if (!regEx("tel").test(mobile)) {
        mobileErrorMsg = "Please enter valid mobile number.";
      } else {
        mobileErrorMsg = "";
      }


      this.formPayload = {
        ...formPayload,
        name: { ...formPayload.name, error: nameErrorMsg },
        email: { ...formPayload.email, error: emailErrorMsg },
        mobile: { ...formPayload.mobile, error: mobileErrorMsg }
      };
      // show error message
      if (
        isEmpty(nameErrorMsg) &&
        isEmpty(emailErrorMsg) &&
        isEmpty(mobileErrorMsg) &&
        regEx("name").test(name) &&
        regEx("email").test(email) &&
        regEx("tel").test(mobile)
      ) {
        this.isValidForm = true;
      }
      // handle submit;
      if (this.isValidForm) {
        return true;
      } else {
        e.preventDefault();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.contact_form {
}
</style>
